import _ from 'lodash';

export function getValidationClasses(formProps) {
  const validationProps = ['active', 'invalid', 'valid', 'pristine', 'touched'];
  return _(validationProps)
    .map(prop => (formProps[prop] ? `is-${prop}` : null))
    .compact()
    .join(' ');
}

export function getErrorDescriptor(inputName: string, hasError: boolean) {
  return hasError ? `${inputName}-error` : '';
}

interface AriaProps {
  'aria-describedBy'?: string[];
  'aria-invalid'?: boolean;
}

export function getAriaProps(inputName: string, hasError: boolean, otherDescribedBy: any[] = []): AriaProps {
  const ret = {};

  const errorDescriptor = getErrorDescriptor(inputName, hasError);
  const describedByValues = _.compact(otherDescribedBy.concat(errorDescriptor));
  if (!_.isEmpty(describedByValues)) {
    ret['aria-describedby'] = describedByValues.join(' ');
  }

  if (hasError) {
    ret['aria-invalid'] = true;
  }

  return ret;
}

// We normalize HTML IDs to not have periods in them for a couple reasons:
// 1) It's confusing to have periods in selectors because with #id.something, is it an ID? An ID/class pair?
// 2) When we wrote some tests, Enzyme didn't support escaping selectors:
// https://github.com/airbnb/enzyme/issues/439
export const getIdFromName = (name: string) => name.replace(new RegExp('\\.', 'g'), '-');
